export default __webpack_public_path__ + "static/media/hauberk_of_the_farseeker.c412390a.jpg";